import * as _ from 'lodash';
import useOpoBaseList from "@nkr/store/opo/hooks/use-opo-base-list";

type TProps = {
    className: string,
    value: string,
    unselectedText: string,
    includeCenters: boolean,
    onChange: (opoId: string) => void
}

const OpoDropDown = ({ value, className, unselectedText, includeCenters, onChange }: TProps) => {
    const { list, loading, error } = useOpoBaseList();

    if (error) {
        return (<div className={className}>{error}</div>);
    }

    const opoList = list.filter(x => x.isCenter == false);
    const centerList = list.filter(x => x.isCenter);

    const opoOptions = _.sortBy(opoList.filter(x => x.name), x => x.name).map((l, i) => <option key={i} value={l.id}>{l.name}</option>);
    const centerOptions = _.sortBy(centerList.filter(x => x.name), x => x.name).map((l, i) => <option key={i} value={l.id}>{l.name}</option>);

    if (includeCenters)
        return (
            <select className={className} value={value} onChange={(e) => onChange(e.target.value)}>
                <option value="">{unselectedText}</option>
                <optgroup label='OPO'>
                    {opoOptions}
                </optgroup>
                <optgroup label='CENTER'>
                    {centerOptions}
                </optgroup>
            </select>
        );

    return (
        <select className={className} value={value} onChange={(e) => onChange(e.target.value)}>
            <option value="">{unselectedText}</option>
            {opoOptions}
        </select>
    );
}

export default OpoDropDown;
